import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { Box, Flex, IconButton } from "@chakra-ui/react";
import { useState } from "react";
import CreateImageView from "./create_image_view";
import GenImage from "./gen_image";
import GenImageHistory from "./gen_image_history";

const CenterMainView = () => {
  const [isRightPanelCollapsed, setIsRightPanelCollapsed] = useState(false);

  return (
    <Box h="100%">
      <Flex w="100%" h="100%" mb="10px">
        <Flex h="100%" flex={1} flexDirection="column">
          <Box h="0px" flex={1} mb="20px">
            <CreateImageView />
          </Box>

          <GenImage />
        </Flex>

        <Box
          position="relative"
          w={isRightPanelCollapsed ? "18px" : "180px"}
          minW={isRightPanelCollapsed ? "18px" : "180px"}
          h="100%"
          transition="width 0.24s ease, min-width 0.24s ease"
        >
          <IconButton
            aria-label={isRightPanelCollapsed ? "展开右侧区域" : "收起右侧区域"}
            icon={isRightPanelCollapsed ? <ChevronLeftIcon /> : <ChevronRightIcon />}
            size="sm"
            position="absolute"
            top="14px"
            left={isRightPanelCollapsed ? "-6px" : "-12px"}
            zIndex={3}
            minW="24px"
            w="24px"
            h="48px"
            borderRadius="12px"
            border="1px solid #27314D"
            bg="#171920"
            color="#DCE3FF"
            _hover={{ bg: "#1F2533", borderColor: "#496AE1" }}
            _active={{ bg: "#222A3B" }}
            boxShadow="0 8px 24px rgba(0, 0, 0, 0.24)"
            onClick={() => setIsRightPanelCollapsed((prev) => !prev)}
          />

          <Flex
            w="100%"
            h="100%"
            flexDirection="column"
            opacity={isRightPanelCollapsed ? 0 : 1}
            pointerEvents={isRightPanelCollapsed ? "none" : "auto"}
            overflow="hidden"
            transition="opacity 0.16s ease"
          >
            <Box flex={1} mb="10px">
              <Box
                w="170px"
                h="100%"
                ml="10px"
                border="1px solid #27314D"
                boxSizing="border-box"
                color="#fff"
              >
                <GenImageHistory />
              </Box>
            </Box>
          </Flex>
        </Box>
      </Flex>
    </Box>
  );
};

export default CenterMainView;
